import { E_ALERT } from '../types/AlertTypes';
import { MAFIA_ACCESS_ERROR, MAFIA_AUTH_ERROR, MAFIA_ERROR_STATUS, MAFIA_LOGIN_ERROR, MAFIA_PAY_ERROR, MAFIA_SERVER_ERROR, } from '../types/errors';
const getKeyValue = (obj, key) => obj[key];
export const getErrors = (data) => {
    if (!data)
        return [{ type: E_ALERT.ERROR, message: 'Unknown error' }];
    return Object.keys(data).map((key) => 
    // console.log("utils.getErrors", getKeyValue(data, key));
    ({ type: E_ALERT.ERROR, message: getKeyValue(data, key) }));
};
export const getAlertError = (message) => ({ type: E_ALERT.ERROR, message });
export const getAlertSuccess = (message) => ({ type: E_ALERT.SUCCESS, message });
const getLoginKeyString = (key) => {
    if (key === 'username')
        return 'логин';
    if (key === 'password')
        return 'пароль';
    return '';
};
export const getMafiaErrors = (err) => {
    var _a, _b;
    const status = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
    const data = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data;
    if (data === null || data === void 0 ? void 0 : data.humanReadable) {
        return [getAlertError(data.humanReadable)];
    }
    switch (status) {
        case MAFIA_SERVER_ERROR:
            return [getAlertError(`Ошибка сервера, статус ${MAFIA_SERVER_ERROR}`)];
        case MAFIA_ERROR_STATUS:
            if ((data === null || data === void 0 ? void 0 : data.code) === MAFIA_PAY_ERROR && data.players) {
                const messages = data.players.reduce((acc, player) => {
                    // console.log('Match verifyPayment map error', acc)
                    acc.push(getAlertError(`Игрок ${player.name} не оплатил игру`));
                    return acc;
                }, []);
                return messages;
            }
            return [getAlertError(data.description || data.message || '')];
        case MAFIA_AUTH_ERROR:
        case MAFIA_LOGIN_ERROR:
            return [];
        case MAFIA_ACCESS_ERROR:
            return [getAlertError(data.description || data.message || '')];
        default:
            return [getAlertError(`Ошибка ${status}`)];
    }
};
export const getPlayer = (playerId, players) => players === null || players === void 0 ? void 0 : players.find((p) => p.id === playerId);
export const digitsOnly = (e) => {
    const charCode = e.code;
    // console.log(charCode);
    if (+charCode < 48 || +charCode > 57) {
        // digits only
        e.preventDefault();
    }
};
export const getKey = () => Math.ceil(Math.random() * 1000000);
const IdDelim = '__';
export const getUniqueId = (id) => `${getKey().toString()}${IdDelim}${id}`;
export const retrieveId = (id) => id.split(IdDelim)[1];
